export default [
  {
    label: "Mask Name",
    name: "maskName",
    type: "text",
    required: true,
  },
  {
    label: "Price",
    name: "price",
    type: "text",
    required: true,
  },
  {
    label: "Description",
    name: "description",
    type: "text",
  },
  {
    label: "Status",
    name: "IsActive",
    type: "select",
    options: ["Active", "Inactive"],
  },
];
